
import InvoiceHistory from "components/pages/health-facility/invoice-history";

export default function Invoice() {
  return <InvoiceHistory />;
}
